export default "__VITE_ASSET__D1hssOL9__"